import React, { useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { useApi } from "../../../../hooks/useApi";
import { authType } from "../../../../pages/Login";
import { PayHelper } from "../../../../scCommon/scCommonFunc";
import LineBtn from "../../../Button/LineBtn";
import Blank from "../../../DefaultStyles/Blank";
import DotStatus from "../../../DefaultStyles/DotStatus";
import LineBox from "../../../DefaultStyles/LineBox";
import TitleWithLine from "../../../DefaultStyles/TitleWithLine";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import UserDetailPartyInfoFilter from "./UserDetailPartyInfo/UserDetailPartyInfoFilter";
import { userCommentDataState } from "./UserDetailComment";
import { getMyPartyStatusText } from "../../../../AdminApi/commFunc";
import { getSubscriptionNameV3 } from "../../../../ApiTS/ServiceDatasTS_V3";

interface UserDetailPartyInfoProps {
  userId?: string;
}

interface IUserPartyInfo {
  partyId: string;
  servsubsid: number;
  grade: number;
  status: number;
  joinDate: string;
  startdate: string;
  endDate: string;
  exitDate: string;
  period: number;
  ishide?: number;
  sset_value: number;
  mystate: number;
}

export default function UserDetailPartyInfo({
  userId,
}: UserDetailPartyInfoProps) {
  const navigate = useNavigate();
  const auth = useRecoilValue(authType);

  const [page, setPage] = useState(0);
  const [filter, setFilter] = useState({
    state: "",
  });

  const { response } = useApi({
    method: "get",
    url: auth?.userInfo
      ? `user/${userId}/party?page=${page}&size=5` +
        (filter?.state !== "" ? `&state=${filter?.state}` : ``)
      : undefined,
  });

  const partyInfoHeader = [
    "PID",
    "Subs_name",
    "등급",
    "나의 상태",
    "숨기기",
    "생성/가입일",
    "시작일",
    "종료일",
    "파티 약정 기간",
    "상세",
  ];

  return (
    <>
      <UserDetailPartyInfoFilter
        setFilter={setFilter}
        btnDisabled={response?.data?.items?.length === 0}
      />

      <LineBox>
        <>
          <TitleWithLine title="파티 정보" />

          <Blank blankHeight={24} />

          <Table tableHeadData={partyInfoHeader} tableMinWidth={965}>
            <>
              {response?.data?.items?.map((d: IUserPartyInfo) => {
                const isUplusParty = d?.servsubsid === 900001;

                return (
                  <TableBody key={d?.partyId}>
                    <TableBodyItem>{d?.partyId}</TableBodyItem>
                    <TableBodyItem>
                      {getSubscriptionNameV3(d?.servsubsid)}
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.grade === 0 ? "파티장" : "파티원"}
                    </TableBodyItem>
                    <TableBodyItem>
                      <DotStatus
                        text={getMyPartyStatusText(d?.mystate).text}
                        color={getMyPartyStatusText(d?.mystate).color}
                        size="sm"
                      />
                    </TableBodyItem>
                    <TableBodyItem>
                      {d?.ishide === 1 ? "숨기기" : "-"}
                    </TableBodyItem>
                    <TableBodyItem>{d?.joinDate}</TableBodyItem>
                    <TableBodyItem>{d?.startdate}</TableBodyItem>
                    <TableBodyItem>
                      {isUplusParty ? (
                        d?.status === 1 ? (
                          "-"
                        ) : (
                          dayjs(d?.exitDate).add(-1, "day").format("YYYY-MM-DD")
                        )
                      ) : (
                        <>
                          <span
                            style={{
                              textDecoration: d?.exitDate
                                ? "line-through"
                                : "none",
                            }}
                          >
                            {dayjs(d?.endDate)
                              .add(-1, "day")
                              .format("YYYY-MM-DD")}
                          </span>
                          {d?.exitDate && (
                            <span style={{ marginLeft: 4 }}>
                              {dayjs(d?.exitDate)
                                .add(-1, "day")
                                .format("YYYY-MM-DD")}
                            </span>
                          )}
                        </>
                      )}
                    </TableBodyItem>
                    <TableBodyItem>
                      {isUplusParty
                        ? "-"
                        : `${PayHelper.calc_period(
                            "month",
                            d?.startdate,
                            dayjs(d?.endDate)
                              .add(0, "day")
                              .format("YYYY-MM-DD"),
                            d?.joinDate
                          )}개월`}
                    </TableBodyItem>

                    <TableBodyItem>
                      <LineBtn
                        btnText="상세"
                        btnClickEvent={() =>
                          navigate(`/party/info/${d?.partyId}`)
                        }
                      />
                    </TableBodyItem>
                  </TableBody>
                );
              })}
            </>
          </Table>

          <Pagination
            totalPage={response?.status === 200 ? response?.data?.totalPage : 3}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />
        </>
      </LineBox>
    </>
  );
}
